import Router from 'vue-router'
import UserMain from '@/layouts/UserMain.vue'
import Vuex from '@/store'
import { identityMeta } from './meta.js'
import { logOperation } from '@/utils/log'
export const constantRouterMap = [
  {
    path: '/',
    redirect: '/workbench',
    meta: {
      title: ' '
    }
  },
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/FrontPage/FrontPage'),
		meta: {
      title: '登录',
      ...identityMeta
    }
	},
  {
    path: '/oneLogin',
		name: 'oneLogin',
		component: () => import('@/views/FrontPage/OneLogin'),
    meta: {
      title: '一键登录',
      ...identityMeta
    }
  },
	{
		path: '/exercises',
		name: 'exercises',
		component: () => import('@/views/Exercise/Exercise'),
		meta: {
			title: 'iframe练习题'
		}
	},
	{
		path: '/oops',
		name: 'error',
		component: () => import('@/views/404')
	},
	{
		path: '/execl',
		name: 'execl',
		component: () => import('@/views/ResourceManagement/Execl'),
		meta: {
			title: 'oxenAndHorses'
		}
	},
	{
		path: '/workbench',
		component: UserMain,
		meta: identityMeta,
		children: [
			{
				path: '',
				name: 'workbenchMain',
				meta: {
					blockPage: false,
					title: '工作台',
					entry_menu: 'workbenchMain'
				},
				component: () => import('@/views/WorkBench/WorkBench')
			},
			{
				path: 'person',
				name: 'person',
				meta: {
					title: '个人中心',
					entry_menu: ''
				},
				component: () => import('@/views/Person/Index.vue')
			},
			{
				path: 'lessonManagement/:sbid',
				name: 'lessonManagement',
				meta: {
					title: '教案管理 / 列表',
					entry_menu: 'lessonManagement',
					keepAlive: 'lessonManagement'
				},
				component: () => import('@/views/LessonManagement/list.vue')
			},
      {
				path: 'lessonManagement/:sbid/lessonDetailManagement',
				name: 'lessonDetailManagement',
				meta: {
					title: '教案管理 / 详情',
					entry_menu: 'lessonManagement',
					keepAlive: 'lessonDetailManagement'
				},
				component: () => import('@/views/LessonManagement/detail.vue')
			},
			{
				path: 'lectureManagement/:sbid',
				name: 'lectureManagement',
				meta: {
					title: '说课管理 / 列表',
					entry_menu: 'lectureManagement',
					keepAlive: 'lectureManagement'
				},
				component: () => import('@/views/LectureManagement/list.vue')
			},
      {
				path: 'lectureManagement/:sbid/lectureDetailManagement',
				name: 'lectureDetailManagement',
				meta: {
					title: '说课管理 / 详情',
					entry_menu: 'lectureManagement',
					keepAlive: 'lectureDetailManagement'
				},
				component: () => import('@/views/LectureManagement/detail.vue')
			},
			{
				path: 'abilityList/:sbid',
				name: 'abilityList',
				meta: {
					title: '题库管理 / 题库列表',
					entry_menu: 'abilityList',
					keepAlive: 'abilityList'
				},
				component: () => import('@/views/QuestionSetMgn/abilityList.vue')
			},
			{
				path: 'abilityList/:sbid/look',
				name: 'abilityLookDetail',
				meta: {
					title: '题库管理 / 题库列表 / 查看',
					entry_menu: 'abilityList',
					keepAlive: 'abilityLookDetail'
				},
				component: () => import('@/views/QuestionSetMgn/abilityLookDetail.vue')
			},
			{
				path: 'abilityList/:sbid/edit',
				name: 'abilityEditDetail',
				meta: {
					title: '题库管理 / 题库列表 / 编辑',
					entry_menu: 'abilityList',
					keepAlive: 'abilityEditDetail'
				},
				component: () => import('@/views/QuestionSetMgn/abilityEditDetail.vue')
			},
			{
				path: 'abilityList/:sbid/new',
				name: 'abilityNewCreate',
				meta: {
					title: '题库管理 / 题库列表 / 新建',
					entry_menu: 'abilityList',
					keepAlive: 'abilityNewCreate'
				},
				component: () => import('@/views/QuestionSetMgn/abilityNewCreate.vue')
			},
			{
				path: 'abilityList/:sbid/resource',
				name: 'abilityResource',
				meta: {
					title: '题库管理 / 资源管理',
					entry_menu: 'abilityList',
					keepAlive: 'abilityResource'
				},
				component: () => import('@/views/QuestionSetMgn/resource.vue')
			},
			{
				path: 'powerPoint',
				name: 'powerPoint',
				meta: {
					title: '题库管理 / 能力点',
					entry_menu: 'powerPoint',
					keepAlive: 'powerPoint'
				},
				component: () => import('@/views/QuestionSetMgn/powerPoint.vue')
			},
			{
				path: 'knowPoint',
				name: 'knowPoint',
				meta: {
					title: '题库管理 / 知识点',
					entry_menu: 'knowPoint',
					keepAlive: 'knowPoint'
				},
				component: () => import('@/views/QuestionSetMgn/knowPoint.vue')
			},
			{
				path: 'sourceManagement/:sbid',
				name: 'sourceManagement',
				meta: {
					title: '资源管理 / 素材管理',
					entry_menu: 'sourceManagement',
					keepAlive: 'sourceManagement'
				},
				component: () => import('@/views/ResourceManagement/sourceManagement.vue')
			},
			{
				path: 'sourceManagement/:sbid/sourceDetailManagement',
				name: 'sourceDetailManagement',
				meta: {
					title: '资源管理 / 素材管理',
					entry_menu: 'sourceManagement',
					keepAlive: 'sourceDetailManagement'
				},
				component: () => import('@/views/ResourceManagement/sourceDetailManagement.vue')
			},
			{
				path: 'teachingManagement/:sbid',
				name: 'teachingManagement',
				meta: {
					title: '资源管理 / 课件管理',
					entry_menu: 'teachingManagement',
					keepAlive: 'teachingManagement'
				},
				component: () => import('@/views/ResourceManagement/TeachingManagement.vue')
			},
			{
				path: 'teachingManagement/:sbid/coursewareManagement',
				name: 'coursewareManagement',
				meta: {
					title: '资源管理 / 课件管理',
					entry_menu: 'teachingManagement',
					keepAlive: 'coursewareManagement'
				},
				component: () => import('@/views/ResourceManagement/CoursewareManagement.vue')
			},
      {
				path: 'teachingManagement/:sbid/version',
				name: 'version',
				meta: {
					title: '资源管理 / 版本动态',
					entry_menu: 'teachingManagement',
					keepAlive: 'version'
				},
				component: () => import('@/views/ResourceManagement/Version.vue')
			},
      {
				path: 'musicalManagement',
				name: 'musicalManagement',
				meta: {
					title: '作品结构管理 / 曲式列表',
					entry_menu: 'musicalManagement',
					keepAlive: 'musicalManagement'
				},
				component: () => import('@/views/MusicalManagement/musicalList.vue')
			},
      {
				path: 'musicalManagement/view',
				name: 'musicalManagementView',
				meta: {
					title: '作品结构管理 / 详情',
					entry_menu: 'musicalManagement',
					keepAlive: 'musicalManagementView'
				},
				component: () => import('@/views/MusicalManagement/musicalView.vue')
			},
			{
				path: 'test_mgn',
				name: 'testManagement',
				meta: {
					title: '测评管理',
					entry_menu: 'testManagement'
				},
				component: () => import('@/views/TestMgn/EvaluateTabel.vue')
			},
			{
				path: 'performance_value_mgn',
				name: 'performanceValueManagement',
				meta: {
					title: '题型赋分管理',
					entry_menu: 'performanceValueManagement'
				},
				component: () => import('@/views/TestMgn/PerformanceValueManagement.vue')
			},
			// {
			// 	path: 'test_mgn/evaluateConfig',
			// 	name: 'evaluateConfig',
			// 	meta: {
			// 		title: '测评管理 / 编辑',
			// 		entry_menu: 'testManagement'
			// 	},
			// 	component: () => import('@/views/TestMgn/EvaluateConfig.vue')
			// },
			// {
			// 	path: 'activityManagement',
			// 	name: 'activityManagement',
			// 	meta: {
			// 		title: '测评管理 / 活动任务管理',
			// 		entry_menu: 'activityManagement'
			// 		// keepAlive: 'activityManagement'
			// 	},
			// 	component: () => import('@/views/TestMgn/ActivityMgn.vue')
			// },
			// {
			// 	path: 'activityManagement/activityTypeTable',
			// 	name: 'activityTypeTable',
			// 	meta: {
			// 		title: '测评管理 / 活动任务管理',
			// 		entry_menu: 'activityManagement'
			// 	},
			// 	component: () => import('@/views/TestMgn/ActivityTypeTable.vue')
			// },
			// {
			// 	path: 'studentEvaluateTable',
			// 	name: 'studentEvaluateTable',
			// 	meta: {
			// 		title: '测评管理 / 学生指标评价表',
			// 		entry_menu: 'studentEvaluateTable'
			// 		// keepAlive: 'studentEvaluateTable'
			// 	},
			// 	component: () => import('@/views/TestMgn/StudentEvaluateTable.vue')
			// },
			{
				path: 'exam_activity',
				name: 'examActivityManagement',
				meta: {
					title: '权益管理',
					entry_menu: 'examActivityManagement',
					keepAlive: 'ExamActivityManagement'
				},
				component: () => import('@/views/ExamActivity/List.vue')
			},
			{
				path: 'student_mgn',
				name: 'studentManagement',
				meta: {
					title: '学生管理',
					entry_menu: 'studentManagement',
					keepAlive: 'StudentManagement'
				},
				component: () => import('@/views/StudentMgn/StudentList')
			},
      {
				path: 'research_mgn',
				name: 'researchManagement',
				meta: {
					title: '教研管理',
					entry_menu: 'researchManagement',
					keepAlive: 'ResearchManagement'
				},
				component: () => import('@/views/ResearchMgn/list')
			},
			{
				path: 'student_mgn/detail',
				name: 'studentDetail',
				meta: {
					title: '学生详情',
					entry_menu: 'studentManagement',
					keepAlive: 'studentDetail'
				},
				component: () => import('@/views/StudentMgn/StudentDetail.vue')
			},
			{
				path: 'student_mgn/detail/index',
				name: 'indexDetail',
				meta: {
					title: '指标详情',
					entry_menu: 'studentManagement',
					keepAlive: 'indexDetail'
				},
				component: () => import('@/views/StudentMgn/IndexDetail.vue')
			},
			{
				path: 'student_mgn/add',
				name: 'studentManagementAdd',
				meta: {
					title: '新增学生',
					entry_menu: 'studentManagement'
				},
				component: () => import('@/views/StudentMgn/NewEdit')
			},
			{
				path: 'student_mgn/:id',
				name: 'studentManagementView',
				meta: {
					title: '学生详情',
					entry_menu: 'studentManagement'
				},
				component: () => import('@/views/StudentMgn/View')
			},
			{
				path: 'student_mgn/:id/edit',
				name: 'studentManagementEdit',
				meta: {
					title: '编辑学生',
					entry_menu: 'studentManagement'
				},
				component: () => import('@/views/StudentMgn/NewEdit')
			},
			{
				path: 'teacher_mgn',
				name: 'teacherManagement',
				meta: {
					title: '教师管理',
					entry_menu: 'teacherManagement',
					keepAlive: 'TeacherManagement'
				},
				component: () => import('@/views/TeacherMgn/TeacherList')
			},

			{
				path: 'teacher_mgn/add',
				name: 'teacherManagementAdd',
				meta: {
					title: '新增教师',
					entry_menu: 'teacherManagement'
				},
				component: () => import('@/views/TeacherMgn/NewEdit')
			},

			{
				path: 'teacher_mgn/:id/edit',
				name: 'teacherManagementView',
				meta: {
					title: '查看教师',
					entry_menu: 'teacherManagement'
				},
				component: () => import('@/views/TeacherMgn/View.vue')
			},
			{
				path: 'teacher_mgn/:id/edit',
				name: 'teacherManagementEdit',
				meta: {
					title: '编辑教师',
					entry_menu: 'teacherManagement'
				},
				component: () => import('@/views/TeacherMgn/NewEdit')
			},
			{
				path: 'classgrade_mgn',
				name: 'classgradeManagement',
				meta: {
					title: '班级管理',
					entry_menu: 'classgradeManagement',
					keepAlive: 'classgradeManagement'
				},
				component: () => import('@/views/ClassGradeMgn/ClassList')
			},
			{
				path: 'classgrade_view',
				name: 'classView',
				meta: {
					title: '班级管理',
					entry_menu: 'classgradeManagement',
					keepAlive: 'classView'
				},
				component: () => import('@/views/ClassGradeMgn/ClassView')
			},
      {
				path: 'classgrade_student',
				name: 'classstudent',
				meta: {
					title: '班级管理',
					entry_menu: 'classgradeManagement',
					keepAlive: 'classstudent'
				},
				component: () => import('@/views/ClassGradeMgn/ClassStudent')
			},
			{
				path: 'classgrade_mgn/add',
				name: 'classgradeManagementAdd',
				meta: {
					title: '新增班级',
					entry_menu: 'classgradeManagement'
				},
				component: () => import('@/views/ClassGradeMgn/NewEdit')
			},
			{
				path: 'classgrade_mgn/:id/edit',
				name: 'classgradeManagementEdit',
				meta: {
					title: '编辑班级',
					entry_menu: 'classgradeManagement'
				},
				component: () => import('@/views/ClassGradeMgn/NewEdit')
			},
			{
				path: 'school_mgn',
				name: 'schoolManagement',
				meta: {
					title: '学校管理',
					entry_menu: 'schoolManagement',
					keepAlive: 'SchoolManagement'
				},
				component: () => import('@/views/SchoolMgn/List')
			},
			{
				path: 'school_mgn/add',
				name: 'schoolManagementAdd',
				meta: {
					title: '新增学校',
					entry_menu: 'schoolManagement'
				},
				component: () => import('@/views/SchoolMgn/NewEdit')
			},
			{
				path: 'school_mgn/:id/edit',
				name: 'schoolManagementEdit',
				meta: {
					title: '编辑学校',
					entry_menu: 'schoolManagement'
				},
				component: () => import('@/views/SchoolMgn/NewEdit')
			},
			{
				path: 'school_mgn/:id',
				name: 'schoolManagementView',
				meta: {
					title: '学校详情',
					entry_menu: 'schoolManagement'
				},
				component: () => import('@/views/SchoolMgn/View')
			},
			{
				path: 'public_notice',
				name: 'publicNoticeList',
				meta: {
					title: '权限管理',
					entry_menu: 'publicNoticeList',
					keepAlive: 'UserPublicNoticeList'
				},
				component: () => import('@/views/PublicNotice/User/authorityList.vue')
			},
			{
				path: 'teachingAids',
				name: 'teachingAidsList',
				meta: {
					title: '教具管理',
					entry_menu: 'teachingAidsList',
					keepAlive: 'teachingAidsList'
				},
				component: () => import('@/views/TeachingAids/list.vue')
			},
			{
				path: 'public_notice/:id',
				name: 'publicNoticeView',
				meta: {
					title: '通告',
					entry_menu: 'publicNoticeList'
				},
				component: () => import('@/views/PublicNotice/User/View.vue')
			},
			{
				path: 'example_Manage',
				name: 'exampleManage',
				meta: {
					title: '谱例管理',
					entry_menu: 'exampleManage',
					keepAlive: 'ExampleManageList'
				},
				component: () => import('@/views/QuestionFeedback/SpectrumList.vue')
			},
			{
				path: 'example_Manage/:id/edit',
				name: 'exampleManageEdit',
				meta: {
					title: '查看谱例',
					entry_menu: 'exampleManage'
				},
				component: () => import('@/views/QuestionFeedback/SpectrumNewEdit.vue')
			},
      {
				path: 'example_Manage/look/:id',
				name: 'exampleManageLook',
				meta: {
					title: '查看谱例',
					entry_menu: 'exampleManage'
				},
				component: () => import('@/views/QuestionFeedback/SpectrumLook.vue')
			},
			{
				path: 'school_admin_mgn',
				name: 'schoolAdminManagement',
				meta: {
					title: '校管理员管理',
					entry_menu: 'schoolAdminManagement',
					keepAlive: 'SchoolAdminManagement'
				},
				component: () => import('@/views/SchoolAdminMgn/SchoolAdminList')
			},
			{
				path: 'school_admin_mgn/add',
				name: 'schoolAdminManagementAdd',
				meta: {
					title: '新增校管理员',
					entry_menu: 'schoolAdminManagement'
				},
				component: () => import('@/views/SchoolAdminMgn/NewEdit')
			},
			{
				path: 'school_admin_mgn/:id',
				name: 'schoolAdminManagementView',
				meta: {
					title: '教师详情',
					entry_menu: 'schoolAdminManagement'
				},
				component: () => import('@/views/SchoolAdminMgn/View')
			},
			{
				path: 'school_admin_mgn/:id/edit',
				name: 'schoolAdminManagementEdit',
				meta: {
					title: '编辑教师',
					entry_menu: 'schoolAdminManagement'
				},
				component: () => import('@/views/SchoolAdminMgn/NewEdit')
			},
			{
				path: 'evaluation_sheet',
				name: 'evaluationSheet',
				meta: {
					title: '评估表',
					entry_menu: 'evaluationSheet',
					keepAlive: 'evaluationSheet'
				},
				component: () => import('@/views/EvaluationSheet/List')
			},
			{
				path: 'appManagement',
				name: 'appManagement',
				meta: {
					title: '应用管理',
					entry_menu: 'appManagement'
				},
				component: () => import('@/views/AppManagement/View')
			},
			{
				path: 'agency_management',
				name: 'agencyManagement',
				meta: {
					title: '代理管理',
					entry_menu: 'agencyManagement',
					keepAlive: 'AgencyManagement'
				},
				component: () => import('@/views/AgencyManagement/List')
			},
			{
				path: 'basic_setting',
				name: 'basicSetting',
				meta: {
					title: '应用管理',
					entry_menu: 'basicSetting',
					keepAlive: 'BasicSetting'
				},
				component: () => import('@/views/BasicSetting/List')
			},
      {
        path: 'keyManagement',
				name: 'keyManagement',
				meta: {
					title: '激活码管理 / 列表',
					entry_menu: 'keyManagement',
					keepAlive: 'KeyManagement'
				},
				component: () => import('@/views/KeyManagement/list')
      },
      {
        path: 'keyManagement/detail/:id',
				name: 'keyManagementView',
				meta: {
					title: '激活码管理 / 详情',
					entry_menu: 'keyManagement',
					keepAlive: 'keyManagementView'
				},
				component: () => import('@/views/KeyManagement/detail')
      },
      {
        path: 'logManagement',
				name: 'logManagement',
				meta: {
					title: '日志管理',
					entry_menu: 'logManagement',
					keepAlive: 'logManagement'
				},
				component: () => import('@/views/logManagement/list')
      },
      {
        path: 'singAlongManagement',
				name: 'singAlongManagement',
				meta: {
					title: '跟(带)唱读管理',
					entry_menu: 'singAlongManagement',
					keepAlive: 'singAlongManagement'
				},
				component: () => import('@/views/singAlongManagement/list')
      },
      {
        path: 'singAlongManagement/view/:id',
        name: 'singAlongManagementView',
        meta: {
          title: '跟(带)唱读管理 / 详情',
          entry_menu: 'singAlongManagement',
          keepAlive: 'singAlongManagementView'
        },
        component: () => import('@/views/singAlongManagement/view.vue')
      },
		]
	},
	{
		path: '/demo',
		name: 'demo',
		component: () => import('@/views/Demo'),
		meta: {
			title: 'Demo页'
		}
	},
	{
		path: '*',
		redirect: '/oops'
	}
]

let router = new Router({
	mode: 'hash', //后端支持可开
	routes: constantRouterMap,
	scrollBehavior() {
		return {
			y: 0
		}
	}
})

window.routeStartTime = 0

router.beforeEach((to, from, next) => {
  window.routeStartTime = new Date().getTime()
	// 从配置获取 Tab 名称
	const brandTitle = Vuex.state.serverConfig.name ? Vuex.state.serverConfig.name : ''
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = brandTitle + ' - ' + to.meta.title
	} else {
		document.title = brandTitle
	}
	if (to.query.code) {
		router.app.$options.store.dispatch('WECHAT_LOGIN', to.query.code, to.query.state)
	}
	if (to.query.debug !== undefined && to.query.debug && Vuex.state.user.userInfo) {
		Vuex.state.debug = true
	}
	next()
})

router.afterEach((to, from) => {
  const params = {
    home_page_name: from.meta.title, // 初始页面名称
    home_page_title: from.path, // 初始页面路径
    // home_page_duration: (new Date().getTime() - window.routeStartTime) / 1000, // 页面响应时长
    home_page_duration: (new Date().getTime() - window.routeStartTime),
    home_page_referrer: to.path // 前往页面路径
  }
  logOperation(params)
})

// 解决重复路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.message.indexOf('Avoided redundant navigation to current location') == -1) {
			// Non repeated route error
			throw new Error(err)
		}
	})
}

export default router
